import styled from 'styled-components'

export const PartnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-self: center;
  gap: 80px;

  .logos {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 32px;
  }

  .row {
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    gap: 32px;
  }

  @media (max-width: 1180px) {
    padding: 0 16px;
  }

  @media (max-width: 900px) {
    .logos {
      gap: 16px;
    }
    .row {
      gap: 16px;
      flex-wrap: wrap-reverse;
    }
  }

  @media (max-width: 500px) {
    gap: 56px;
    width: 100%;
  }
`
